/**
 * Default settings for Free Shipping Bar module
 */
export const FREE_SHIPPING_BAR_DEFAULTS = {
  layout_style: 'modern',
  message_initial: 'Add {amount} more to get free shipping!',
  message_qualified: 'You qualify for free shipping!',
  show_on_cart: true,
  show_on_checkout: true,
  show_on_mini_cart: true,
  hide_when_qualified: true,
  bar_color: '#28AA85',
  text_color: '#ffffff',
  bg_color: '#0F594B',
};

/**
 * Layout style options for the shipping bar
 */
export const LAYOUT_STYLE_OPTIONS = [
  { value: 'classic', label: 'Classic - Simple solid progress bar' },
  { value: 'modern', label: 'Modern - Animated striped progress bar (Default)' },
];
